export default __webpack_public_path__ + "static/media/icons8-structuralengineer.0e756753.svg";